var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_8860_6998)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2866 0H0V21.939H17.7706V5.48404L12.2866 0Z",
    fill: "#00C650"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2568 4.96875H12.8008L17.7713 9.93931L17.7713 5.48295L17.2568 4.96875Z",
    fill: "url(#paint0_linear_8860_6998)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7715 5.48438L12.2867 -0.00038338C12.2867 3.02876 14.7423 5.48437 17.7715 5.48438Z",
    fill: "#00C650"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63632 15.6367H5.85862C5.84442 15.5361 5.81541 15.4467 5.77162 15.3686C5.72782 15.2893 5.67159 15.2218 5.60294 15.1662C5.53428 15.1106 5.45497 15.0679 5.36501 15.0384C5.27623 15.0088 5.17976 14.994 5.07559 14.994C4.88738 14.994 4.72344 15.0407 4.58376 15.1342C4.44408 15.2266 4.33577 15.3615 4.25883 15.5391C4.18189 15.7154 4.14342 15.9297 4.14342 16.1818C4.14342 16.4411 4.18189 16.6589 4.25883 16.8352C4.33696 17.0116 4.44586 17.1448 4.58554 17.2347C4.72522 17.3247 4.88679 17.3697 5.07027 17.3697C5.17325 17.3697 5.26854 17.3561 5.35613 17.3288C5.44491 17.3016 5.52363 17.262 5.59229 17.2099C5.66094 17.1566 5.71776 17.0921 5.76274 17.0163C5.8089 16.9406 5.84086 16.8542 5.85862 16.7571L6.63632 16.7607C6.6162 16.9276 6.56589 17.0885 6.4854 17.2436C6.40609 17.3975 6.29896 17.5354 6.16402 17.6573C6.03026 17.7781 5.87046 17.8739 5.68461 17.945C5.49996 18.0148 5.29103 18.0497 5.05784 18.0497C4.7335 18.0497 4.44349 17.9763 4.18781 17.8295C3.93331 17.6828 3.73208 17.4703 3.58412 17.1921C3.43734 16.9139 3.36395 16.5772 3.36395 16.1818C3.36395 15.7853 3.43852 15.4479 3.58767 15.1697C3.73682 14.8916 3.93923 14.6797 4.19491 14.5341C4.45059 14.3873 4.73824 14.3139 5.05784 14.3139C5.26854 14.3139 5.46385 14.3435 5.64378 14.4027C5.82488 14.4619 5.98528 14.5483 6.12496 14.6619C6.26463 14.7744 6.37827 14.9123 6.46586 15.0756C6.55464 15.239 6.61146 15.426 6.63632 15.6367ZM9.16029 15.4094C9.14608 15.2662 9.08512 15.1549 8.97741 15.0756C8.86969 14.9963 8.7235 14.9567 8.53884 14.9567C8.41337 14.9567 8.30742 14.9744 8.22101 15.0099C8.1346 15.0443 8.06832 15.0922 8.02215 15.1538C7.97717 15.2153 7.95468 15.2852 7.95468 15.3633C7.95231 15.4284 7.96592 15.4852 7.99552 15.5337C8.02629 15.5823 8.06831 15.6243 8.12158 15.6598C8.17485 15.6941 8.2364 15.7243 8.30624 15.7504C8.37608 15.7752 8.45065 15.7965 8.52996 15.8143L8.85667 15.8924C9.01528 15.9279 9.16088 15.9753 9.29346 16.0344C9.42603 16.0936 9.54085 16.1664 9.63792 16.2528C9.73498 16.3393 9.81015 16.4411 9.86341 16.5582C9.91787 16.6754 9.94568 16.8098 9.94687 16.9613C9.94568 17.1838 9.88886 17.3768 9.77641 17.5401C9.66514 17.7023 9.50416 17.8284 9.29346 17.9183C9.08394 18.0071 8.83122 18.0515 8.53529 18.0515C8.24173 18.0515 7.98605 18.0065 7.76824 17.9165C7.55162 17.8266 7.38235 17.6934 7.26043 17.517C7.13969 17.3395 7.07636 17.1199 7.07045 16.8583H7.81441C7.82269 16.9802 7.85761 17.082 7.91917 17.1637C7.9819 17.2442 8.06536 17.3052 8.16952 17.3466C8.27487 17.3868 8.39384 17.407 8.52641 17.407C8.65662 17.407 8.76966 17.388 8.86555 17.3501C8.96261 17.3123 9.03778 17.2596 9.09104 17.1921C9.14431 17.1246 9.17094 17.0471 9.17094 16.9595C9.17094 16.8778 9.14668 16.8092 9.09814 16.7536C9.0508 16.6979 8.98096 16.6506 8.88863 16.6115C8.79748 16.5724 8.68562 16.5369 8.55305 16.505L8.15709 16.4055C7.85051 16.331 7.60844 16.2144 7.43089 16.0558C7.25333 15.8971 7.16514 15.6835 7.16633 15.4148C7.16514 15.1946 7.22374 15.0022 7.34211 14.8377C7.46166 14.6732 7.62561 14.5447 7.83394 14.4524C8.04227 14.3601 8.27902 14.3139 8.54417 14.3139C8.81405 14.3139 9.04961 14.3601 9.25084 14.4524C9.45326 14.5447 9.61069 14.6732 9.72314 14.8377C9.8356 15.0022 9.8936 15.1928 9.89715 15.4094H9.16029ZM11.121 14.3636L11.9999 17.1264H12.0336L12.9143 14.3636H13.7666L12.513 18H11.5222L10.2669 14.3636H11.121Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_8860_6998",
    x: 0,
    y: -1,
    width: 17.7715,
    height: 23.9375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8860_6998"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_8860_6998",
    result: "effect2_innerShadow_8860_6998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8860_6998",
    x1: 13.9149,
    y1: 3.85466,
    x2: 18.8854,
    y2: 8.82522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.2950039e9bd97b4a575f1079453310e5.svg";
export { ForwardRef as ReactComponent };